export enum PaymentStatus {
    ALL = "all",
    PENDING = "Pending",
    CONFIRMED = "Confirmed",
    COLLECTED = "Collected",
    UNREACHABLE = "Unreachable",
    DECLINED = "Declined",
    REFUNDED = "Refunded",
}

export enum OfflinePaymentStatus {
    ALL = "all",
    PENDING = "Pending",
    COLLECTED = "Collected",
    UNREACHABLE = "Unreachable",
}

export enum PaymentTypes {
    ALL = "all",
    CASH = "Cash",
    CHEQUE = "Cheque",
    CITY_BANK = "City",
    EASTERN_BANK = "EBL",
    BRAC_BANK = "Brac",
    DBBL = "DBBL",
    BKASH = "Bkash",
    NAGAD = "Nagad",
    AMEX = "Amex",
    NEXUSPAY = "NexusPay",
}

export enum OfflinePaymentTypes {
    ALL = "all",
    CASH = "Cash",
    CHEQUE = "Cheque",
}

export enum RefundPaymentTypes {
    ALL = "all",
    CITY_BANK = "City",
    EASTERN_BANK = "EBL",
    BRAC_BANK = "Brac",
    DBBL = "DBBL",
    BKASH = "Bkash",
    NAGAD = "Nagad",
}

export enum DonationPaymentTypes {
    CASH = "Cash",
    CHEQUE = "Cheque",
    Visa = "Visa",
    Master = "Master",
    NexusPay = "NexusPay",
    Amex = "Amex",
    BKASH = "Bkash",
    NAGAD = "Nagad",
}

export enum DonationDetailsPaymentStatus {
    CONFIRMED = 0,
    PENDING = 1,
    ALL = 2
}